import { Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import PageLayout from "./PageLayout";
import Loader from "./Loader/Loader";

function AppShell() {
  const location = useLocation();

  /* -------------------------------- */
  /* RENDER METHODS */
  /* -------------------------------- */

  // Scoped to the content area on purpose. The sidebar and the header stay
  // mounted while the next page chunk downloads, so a navigation no longer
  // blanks the whole screen the way a top level Suspense fallback did.
  function renderContentLoader() {
    return (
      <div className="flex h-full items-center justify-center">
        <Loader />
      </div>
    );
  }

  function render() {
    return (
      <PageLayout>
        <Suspense fallback={renderContentLoader()}>
          {/* Keyed on the path so the slide in animation replays per page,
              now that the layout around it is no longer remounted. */}
          <div key={location.pathname} className="animate-slideIn">
            <Outlet />
          </div>
        </Suspense>
      </PageLayout>
    );
  }

  return render();
}

export default AppShell;
